import React from 'react';
import styles from './HeadBanner.module.scss';

const HeadBanner = props => {
  return (
    <div>
      <div className={styles.heroBanner3}>
        <div className={'container'}>
          <div className={'row'}>
            <div className={'col-12'}>
              <h1>{props.title}</h1>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-md-7 col-sm-12'}>
              <p className={styles.content}>{props.content}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadBanner;
